import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../guard/auth.guard'
import { AsignacionMenuComponent } from './asignacion-menu.component'
import { ServiciosAlimentosComponent } from './servicios-alimentos/servicios-alimentos.component'

const routes: Routes = [
  {
    path: '',
    component: AsignacionMenuComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: ServiciosAlimentosComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AsignacionMenuRoutingModule {}
